/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

import LocalData from "./Sections/PortfolioData";

// Section Imports
import IntroSection from "./Sections/IntroSection";
import ProjectsSection from "./Sections/ProjectsSection";
import ExperienceSection from "./Sections/ExperienceSection";
import CertificationsSection from "./Sections/CertificationsSection";
import EducationSection from "./Sections/EducationSection";
import CreditsSection from "./Sections/CreditsSection";

// Modal Imports
import ProjectModal from "./Sections/Modals/ProjectModal";

// Image
import bgImage from "assets/images/portfolio/PortfolioGamesSplash.png";

class ProjectEntry {
  #name = null;
  #genre = null;
  #shipInfo = null;
  #myRole = null;
  #tools = null;
  #about = null;
  #contributions = [];
  #videoUrl = null;
  #videoList = [];

  constructor(name, genre, shipInfo, myRole, tools, about, contributions) {
    this.#name = name;
    this.#genre = genre;
    this.#shipInfo = shipInfo;
    this.#myRole = myRole;
    this.#tools = tools;
    this.#about = about;

    if (contributions && contributions.length > 0) {
      this.#contributions.push(...contributions);
    }
  }

  SetVideoUrl(vUrl) {
    this.#videoUrl = vUrl;
  }

  SetVideoList(vList) {
    if (vList && vList.length > 0) {
      this.#videoList.push(...vList);
    }
  }

  get GetName() {
    return this.#name;
  }

  get GetNameNoSpaces() {
    return this.#name.replace(/\s/g, "");
  }

  get GetGenre() {
    return this.#genre;
  }

  get GetShipInfo() {
    return this.#shipInfo;
  }

  get GetMyRole() {
    return this.#myRole;
  }

  get GetTools() {
    return this.#tools;
  }

  get GetAbout() {
    return this.#about;
  }

  get GetContributions() {
    return this.#contributions;
  }

  get GetVideoUrl() {
    return this.#videoUrl;
  }

  get GetVideoList() {
    return this.#videoList;
  }
}

function ParseProjectData(dataIn) {
  let projectData = new Map();
  for (let i = 0; i < dataIn.length; i++) {
    let project = dataIn[i].project.details;
    let data = new ProjectEntry(
      project.name,
      project.genre,
      project.shipInfo,
      project.myRole,
      project.tools,
      project.about,
      project.contributions
    );

    if (project.videoUrl) {
      data.SetVideoUrl(project.videoUrl);
    }

    if (project.videoList) {
      data.SetVideoList(project.videoList);
    }

    projectData.set(dataIn[i].project.id, data);
  }

  return projectData;
}

function Portfolio() {
  const [redfallshow, redfallsetShow] = React.useState(false);
  const toggleRedfallModal = () => redfallsetShow(!redfallshow);

  const [runeshow, runesetShow] = React.useState(false);
  const toggleRuneModal = () => runesetShow(!runeshow);

  const [sbshow, sbsetShow] = React.useState(false);
  const toggleSBModal = () => sbsetShow(!sbshow);

  const [swcshow, swcsetShow] = React.useState(false);
  const toggleSWCModal = () => swcsetShow(!swcshow);

  const [tatshow, tatsetShow] = React.useState(false);
  const toggleTATModal = () => tatsetShow(!tatshow);

  const [jamshow, jamsetShow] = React.useState(false);
  const toggleJamModal = () => jamsetShow(!jamshow);

  let data = LocalData();
  let allProjects = ParseProjectData(data.projects);
  let redfallData = allProjects.get("redfall");
  let runeData = allProjects.get("rune");
  let sbData = allProjects.get("sb");
  let swcData = allProjects.get("swc");
  let tatData = allProjects.get("tat");
  let jamsData = allProjects.get("jams");

  return (
    <>
      <Grid container spacing={0} alignItems="flex-start">
        <Grid
          item
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={6}
          ml={{ xs: "auto", lg: 1 }}
          mr={{ xs: "auto", lg: 1 }}
        >
          <IntroSection />

          <ProjectsSection
            toggleRedfallModal={toggleRedfallModal}
            toggleRuneModal={toggleRuneModal}
            toggleSBModal={toggleSBModal}
            toggleSWCModal={toggleSWCModal}
            toggleTATModal={toggleTATModal}
            toggleJamModal={toggleJamModal}
          />

          <ProjectModal
            projectData={redfallData}
            isVisible={redfallshow}
            toggleCallback={toggleRedfallModal}
          />

          <ProjectModal
            projectData={runeData}
            isVisible={runeshow}
            toggleCallback={toggleRuneModal}
          />

          <ProjectModal projectData={sbData} isVisible={sbshow} toggleCallback={toggleSBModal} />

          <ProjectModal projectData={swcData} isVisible={swcshow} toggleCallback={toggleSWCModal} />

          <ProjectModal projectData={tatData} isVisible={tatshow} toggleCallback={toggleTATModal} />

          <ProjectModal
            projectData={jamsData}
            isVisible={jamshow}
            toggleCallback={toggleJamModal}
          />

          <ExperienceSection />

          <CreditsSection />

          <CertificationsSection />

          <EducationSection />
        </Grid>
        <Grid item xs={12} lg={5.75}>
          <MKBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(50% - 2rem)"
            height="calc(100vh - 2rem)"
            ml={0}
            mt={2}
            borderRadius="lg"
            sx={{
              backgroundImage: `url(${bgImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              position: "fixed",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Portfolio;
